import {useCallback} from 'react';
import {useAppDispatch} from 'store/hooks';
import {titleUpdated} from '../headSlice';

export const useSetBrowserTabTitle = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (title?: string) => {
      dispatch(titleUpdated(title));
    },
    [dispatch],
  );
};
